import { ConfirmationModalComponent } from 'commons/components';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { useTranslation } from 'core/i18n/i18n';
import { PopupProps } from 'react-popup-manager';
import { BULK_DELETE_MATERIALS_KEY } from './bulk-delete-materials-confirmation.constants';

interface BulkDeleteMaterialsConfirmationProps extends PopupProps {
    count: number;
    onConfirm: () => Promise<unknown>;
}

export const BulkDeleteMaterialsConfirmationComponent: React.FC<BulkDeleteMaterialsConfirmationProps> = ({
    isOpen,
    onClose,
    count,
    onConfirm,
}) => {
    const { t } = useTranslation();

    return (
        <ConfirmationModalComponent
            isOpen={isOpen}
            onClose={onClose}
            title={t(BULK_DELETE_MATERIALS_KEY.confirmTitle)}
            buttonText={t(BULK_DELETE_MATERIALS_KEY.confirmButton)}
            actionOnClick={onConfirm}
        >
            <PocTypography>{t(BULK_DELETE_MATERIALS_KEY.confirmMessage, { count })}</PocTypography>
        </ConfirmationModalComponent>
    );
};
